<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Partner Transaction</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.partnerTransactionId" placeholder=""></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Loan Id</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.loan_id"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Project</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty>
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template v-slot:cell(repayment_date)="data">{{ data.item.repayment_date | moment("YYYY MMM DD") }}</template>
        <template v-slot:cell(principal)="data">{{ data.item.principal | numFormat("0,0.00") }}</template>
        <template v-slot:cell(interest_repaid)="data">{{ data.item.interest_repaid | numFormat("0,0.00") }}</template>
        <template v-slot:cell(total_repayment)="data">{{ data.item.total_repayment | numFormat("0,0.00") }}</template>


        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="5" class="text-center"><span class="">TOTAL</span></b-th>
            <b-th class="text-right"><span class="text-right">{{tblData.principal | numFormat('0,0.00')}}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{tblData.interest_repaid | numFormat('0,0.00')}}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{tblData.total_repayment | numFormat('0,0.00')}}</span></b-th>

          </b-tr>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import repayment from "../../apis/repayment";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      projectsFilt:[{
        value:'',text:'-- ALL --'
      }],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "repaymentTransactionId",
        sortDesc: false,
        tgl1: moment().startOf('M').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD'),
        partnerTransactionId: "",
        loan_id: "",
        total_repayment:0,principal:0,interest_repaid:0,        pjxkey:''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "repayment_date",
          label: "Repayment Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "loan_id",
          label: "Loan Id",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "customerID",
          label: "Customer ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "debtorFullName",
          label: "Debtor FullName",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "principal",
          label: "principal",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "interest_repaid",
          label: "interest_repaid",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "total_repayment",
          label: "total_repayment",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true
        },
      ];
      return fields;
    },
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
    if (this.$route) {
      if(this.$route.params.tgl1 || this.$route.params.tgl2){
        const { tgl1, tgl2 } = this.$route.params;
        this.tblData.tgl1 = tgl1;
        this.tblData.tgl2 = tgl2;
      }
      if(this.$route.query.tgl1 || this.$route.query.tgl2){
        const { tgl1, tgl2 } = this.$route.query;
        this.tblData.tgl1 = tgl1;
        this.tblData.tgl2 = tgl2;
      }
    }
  },
  methods: {
    async adddebitur() {
      router.push({ name: "loan.master-debitur-form" });
    },
    async editdebitur() {
      if (this.model.nasabahkey && this.model.nasabahkey !== "undefined") {
        const filter = this.$store.state.filter;
        filter.debiturList = this.tblData;
        this.$store.commit("filter", filter);
        router.push({ name: 'loan.master-debitur-form', params: { nasabahkey: this.model.nasabahkey } });
      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },

    async collectorhistory() {
      if (this.model.nasabahkey) {
        router.push({
          name: "loan.history-collector-to-debitur",
          params: { nasabahkey: this.model.nasabahkey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async data() {
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.debiturList) {
        this.tblData[key] = filter.debiturList[key];
        filtered = true;
      }
      if (filtered === true) {
        this.showFilter = filtered;
        delete filter.debiturList;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if (this.tblData.tgl1 || this.tblData.tgl2) {
        if ((this.tblData.tgl2 || "") == "") {
          this.tblData.tgl2 = this.tblData.tgl1;
        }
      }

      const list = await repayment.list(this.tblData);
      return list;
    },
    async exportxls() {
      try {
        await repayment.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: 'repaymentupload',
        customQuery: "",
        tgl1: "",
        tgl2: "",
        partnerTransactionId: "",
        loan_id: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>